import { useEffect, useRef } from "react";

export function useReceiveMessage(url: string | undefined) {
  const iframeRef = useRef(null);

  const receiveMessage = (event: MessageEvent) => {
    const origin = event.origin;
    if (iframeRef.current !== null && event.data) {
      if (url && !url.startsWith(origin)) {
        return;
      }

      if (
        !url &&
        window.location.protocol + "//" + window.location.host !== origin
      ) {
        return;
      }

      iframeRef.current.style.height = event.data + "px";
    }
  };

  useEffect(() => {
    window.addEventListener("message", receiveMessage, false);
    return () => window.removeEventListener("message", receiveMessage);
  });

  return iframeRef;
}